import { MdCalendarToday } from 'react-icons/md';
import SectionLabelWithIcon from 'components/typography/SectionLabelWithIcon';
import { fontSemiBold, secondaryColor } from './styleConstants';

export default function Itinerary({ xMargins = {} }) {
  return (
    <>
      <SectionLabelWithIcon
        label="Itinerary"
        icon={<MdCalendarToday />}
        iconClassName="text-2xl"
        style={{
          paddingBottom: '1rem',
          borderBottomWidth: '1px',
          ...xMargins,
        }}
        isPdf
      />
      <p
        style={{
          marginTop: '.5rem',
          marginBottom: '.5rem',
          fontWeight: fontSemiBold,
          ...xMargins,
        }}
      >
        10 June 2022
      </p>
      <div style={{ display: 'flex', ...xMargins }}>
        <div
          style={{
            marginRight: '1rem',
            minWidth: '80px',
            maxWidth: '80px',
            width: '80px',
          }}
        >
          9:00
        </div>
        <div
          style={{
            paddingLeft: '2rem',
            paddingBottom: '1rem',
            borderLeftWidth: '1px',
            position: 'relative',
          }}
        >
          <p>Check-in at London heathrow, North Terminal</p>
          <p>2 Adults</p>
          <div
            style={{
              height: '20px',
              width: '20px',
              borderRadius: '50%',
              background: secondaryColor,
              position: 'absolute',
              top: '5px',
              left: '-10px',
            }}
          />
        </div>
      </div>
      <div style={{ display: 'flex', ...xMargins }}>
        <div
          style={{
            marginRight: '1rem',
            minWidth: '80px',
            maxWidth: '80px',
            width: '80px',
          }}
        >
          <div>12:00</div>
        </div>
        <div
          style={{
            paddingLeft: '2rem',
            paddingBottom: '1rem',
            borderLeftWidth: '1px',
            position: 'relative',
          }}
        >
          <p>
            Depart London Heathrow on British Airways Flight BA768 (Operated by
            British Airways) to Marrakech Airport
          </p>
          <p>2 Adults - No Stops</p>
          <p style={{ marginTop: '1rem', marginBottom: '1rem' }}>Inclusions</p>
          <p className="border-slate-600 border-l-[4px] pl-2 my-2">
            Large cabin bag
          </p>
          <p className="border-slate-600 border-l-[4px] pl-2 my-2">
            Hold bag 15kg
          </p>
          <div
            style={{
              height: '20px',
              width: '20px',
              borderRadius: '50%',
              background: secondaryColor,
              position: 'absolute',
              top: '5px',
              left: '-10px',
            }}
          />
        </div>
      </div>
      <div style={{ display: 'flex', ...xMargins }}>
        <div
          style={{
            marginRight: '1rem',
            minWidth: '80px',
            maxWidth: '80px',
            width: '80px',
          }}
        >
          15:00
        </div>
        <div
          style={{
            paddingLeft: '2rem',
            paddingBottom: '1rem',
            position: 'relative',
          }}
        >
          <p>Arrive at Marrackech Airport, South Terminal</p>
          <p>2 Adults</p>
          <div
            style={{
              height: '20px',
              width: '20px',
              borderRadius: '50%',
              background: secondaryColor,
              position: 'absolute',
              top: '5px',
              left: '-10px',
            }}
          />
        </div>
      </div>

      <p
        style={{
          marginTop: '.5rem',
          marginBottom: '.5rem',
          fontWeight: fontSemiBold,
          ...xMargins,
        }}
      >
        11 June 2022
      </p>
      <div style={{ display: 'flex', ...xMargins }}>
        <div
          style={{
            marginRight: '1rem',
            minWidth: '80px',
            maxWidth: '80px',
            width: '80px',
          }}
        >
          07:30
        </div>
        <div
          style={{
            paddingLeft: '2rem',
            paddingBottom: '1rem',
            borderLeftWidth: '1px',
            position: 'relative',
          }}
        >
          <p>Pick up from Imperial Plaza</p>
          <p>2 Adults - Part of the Marrakech Tour</p>
          <div
            style={{
              height: '20px',
              width: '20px',
              borderRadius: '50%',
              background: secondaryColor,
              position: 'absolute',
              top: '5px',
              left: '-10px',
            }}
          />
        </div>
      </div>
      <div style={{ display: 'flex', ...xMargins }}>
        <div
          style={{
            marginRight: '1rem',
            minWidth: '80px',
            maxWidth: '80px',
            width: '80px',
          }}
        >
          08:30
        </div>
        <div
          style={{
            paddingLeft: '2rem',
            paddingBottom: '1rem',
            position: 'relative',
          }}
        >
          <p>Marrakech Tour</p>
          <p>2 Adults - Part of the Marrakach Tour</p>
          <div
            style={{
              height: '20px',
              width: '20px',
              borderRadius: '50%',
              background: secondaryColor,
              position: 'absolute',
              top: '5px',
              left: '-10px',
            }}
          />
        </div>
      </div>
    </>
  );
}
